import { BaseEvent } from "@fideus/analytics";

interface AuthRedirectData {
  /** The HTTP status code that triggered the redirect (401 or 403) */
  status: number;
  /** The API URL that returned the auth error */
  url: string;
}

export class AuthRedirectEvent extends BaseEvent<AuthRedirectData> {
  override readonly "detail-type" = "Auth Redirect" as const;
}
